<span class="modal-close-icon">
  <i class="fa-regular fa-circle-xmark" (click)="requestClose()"></i>
</span>

<div class="modal-body">
  <div class="row align-items-center mb-3">
    <div class="col">
      <h1 class="mb-0">Children Details</h1>
    </div>
    <div class="col-auto">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        (click)="openAddForm()"
        [disabled]="saving || showAddForm || editingChildId !== null"
      >
        <i class="fas fa-plus me-1"></i> Add child
      </button>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

  <div class="card mb-3" *ngIf="showAddForm">
    <div class="card-body">
      <h2 class="h6 mb-3">New child</h2>
      <form [formGroup]="childForm" (ngSubmit)="saveNewChild()">
        <div class="row">
          <div class="col-md-6 mb-2">
            <label class="form-label">First name</label>
            <input type="text" class="form-control" formControlName="firstname" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">Last name</label>
            <input type="text" class="form-control" formControlName="lastname" />
          </div>
          <div class="col-md-4 mb-2">
            <label class="form-label">Age</label>
            <input type="number" class="form-control" formControlName="age" min="0" />
          </div>
          <div class="col-md-8 mb-2">
            <label class="form-label">Allergies and health notes</label>
            <input type="text" class="form-control" formControlName="allergy" />
          </div>
        </div>
        <div class="mt-2">
          <button type="submit" class="btn btn-default add-edit-button btn-sm me-2" [disabled]="saving">
            Save
          </button>
          <button type="button" class="btn btn-light cancel-button btn-sm" (click)="cancelEditForm()" [disabled]="saving">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="table-responsive position-relative" *ngIf="!loading">
    <div class="children-loading" *ngIf="saving">
      <span class="text-muted">Saving…</span>
    </div>
    <table class="table children-table table-hover" *ngIf="user?.children?.length; else noChildren">
      <thead>
        <tr>
          <th>Child Name</th>
          <th>Age</th>
          <th>Allergies and health notes</th>
          <th class="text-end children-actions-col">Actions</th>
          <th class="text-center" style="width: 48px"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let child of user.children; let i = index">
          <tr *ngIf="editingChildId !== child.id" (click)="rowClick(i, $event)">
            <td>{{ child.firstname }} {{ child.lastname }}</td>
            <td>{{ child.age }}</td>
            <td>{{ child.allergy }}</td>
            <td class="text-end text-nowrap">
              <button
                type="button"
                class="btn btn-link btn-sm py-0"
                (click)="startEdit(child); $event.stopPropagation()"
                [disabled]="saving || showAddForm"
              >
                Edit
              </button>
              <button
                type="button"
                class="btn btn-link btn-sm text-danger py-0"
                (click)="confirmDeleteChild(child, $event)"
                [disabled]="saving || showAddForm"
              >
                Delete
              </button>
            </td>
            <td class="text-center">
              <i
                [class]="'fas' + (expandedRowIndex === i ? ' fa-chevron-up' : ' fa-chevron-down')"
              ></i>
            </td>
          </tr>

          <tr *ngIf="editingChildId === child.id">
            <td colspan="5">
              <form [formGroup]="childForm" (ngSubmit)="saveEditChild()">
                <div class="row">
                  <div class="col-md-4 mb-2">
                    <label class="form-label">First name</label>
                    <input type="text" class="form-control" formControlName="firstname" />
                  </div>
                  <div class="col-md-4 mb-2">
                    <label class="form-label">Last name</label>
                    <input type="text" class="form-control" formControlName="lastname" />
                  </div>
                  <div class="col-md-4 mb-2">
                    <label class="form-label">Age</label>
                    <input type="number" class="form-control" formControlName="age" min="0" />
                  </div>
                  <div class="col-12 mb-2">
                    <label class="form-label">Allergies and health notes</label>
                    <input type="text" class="form-control" formControlName="allergy" />
                  </div>
                </div>
                <button type="submit" class="btn btn-default add-edit-button btn-sm me-2" [disabled]="saving">
                  Save
                </button>
                <button type="button" class="btn btn-light cancel-button btn-sm" (click)="cancelEditForm()" [disabled]="saving">
                  Cancel
                </button>
              </form>
            </td>
          </tr>

          <tr *ngIf="expandedRowIndex === i && editingChildId !== child.id" style="background-color: #fafafa">
            <td colspan="5">
              <div class="table-responsive" *ngIf="userBookedLessons[child.id]?.length > 0">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th>Lesson</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Teacher Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let lesson of userBookedLessons[child.id]!">
                      <td>{{ lesson.name }}</td>
                      <td>{{ lesson.bookingDate }}</td>
                      <td>{{ lesson.startTime }} - {{ lesson.endTime }}</td>
                      <td>{{ lesson.teacherFirstName }} {{ lesson.teacherLastNameName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-muted" *ngIf="!userBookedLessons[child.id]?.length">
                There are no booked lessons for this child.
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <ng-template #noChildren>
      <p class="text-muted mb-0" *ngIf="!showAddForm">No children yet. Click &quot;Add child&quot; to create one.</p>
    </ng-template>
  </div>

  <div *ngIf="loading" class="text-muted py-4 text-center">Loading…</div>
</div>
